import { Map } from "immutable"

import {
  SET_STATE, ADD_ALERT, LOGIN, LOGOUT,
  REFRESH_USERS, CREATE_USER, DELETE_USER, UPDATE_USER, UPDATE_PASSWORD,
  REFRESH_DEALERS, CREATE_DEALER, DELETE_DEALER, UPDATE_DEALER,
  REFRESH_ORDERS, CREATE_ORDER, DELETE_ORDER, UPDATE_ORDER,
  REFRESH_RETURNS, CREATE_RETURN, DELETE_RETURN, UPDATE_RETURN,
  REFRESH_EXPENSES, CREATE_EXPENSE, DELETE_EXPENSE, UPDATE_EXPENSE,
} from "../constants/ActionTypes"

export default (state = Map(), action) => {
// export default (state = dummy_orders, action) => {
  switch (action.type) {
    case SET_STATE:
      return state.merge(action.new_state)

    case ADD_ALERT:
      return state.setIn(["alerts", action.alert_type], action.alert_message)

    case LOGIN:
      break
    case LOGOUT:
      break

    case REFRESH_USERS:
      break
    case CREATE_USER:
      // return state.setIn(["users", action.user.get("username")], action.user)
      break
    case UPDATE_USER:
      // return state.setIn(["users", action.user.get("username")], action.user)
      break
    case DELETE_USER:
      // return state.deleteIn(["users", action.user.get("username")])
      break
    case UPDATE_PASSWORD:
      // if ((state.getIn(["users", action.username, "password"]) === action.password_old) && 
      //   (action.password_new === action.password_confirmation)) {
      //   return state.setIn(["users", action.username, "password"], action.password_new)
      // }
      // return state
      break

    case REFRESH_DEALERS:
      break
    case CREATE_DEALER:
      break
    case UPDATE_DEALER:
      break
    case DELETE_DEALER:
      break
    
    case REFRESH_ORDERS:
      break
    case CREATE_ORDER:
      break
    case UPDATE_ORDER:
      break
    case DELETE_ORDER:
      break
    
    case REFRESH_RETURNS:
      break
    case CREATE_RETURN:
      break
    case UPDATE_RETURN:
      break
    case DELETE_RETURN:
      break
    
    case REFRESH_EXPENSES:
      break
    case CREATE_EXPENSE:
      break
    case UPDATE_EXPENSE:
      break
    case DELETE_EXPENSE:
      break
      
    default:
  }

  return state
}


// WEBPACK FOOTER //
// ./src/reducers/index.js